import React from 'react';

export default function Footer() {
  return (
    <footer className='am-footer am-footer-new'>
      <div className='am-footer-wave' aria-hidden>
        <svg
          viewBox='0 0 1440 160'
          xmlns='http://www.w3.org/2000/svg'
          preserveAspectRatio='none'
          focusable='false'
          aria-hidden='true'
        >
          {/* Draw from bottom-left to bottom-right then up to the top to create a filled wave */}
          <path fill='#ffffff' d='M0,160 C360,120 720,120 1440,160 L1440,0 L0,0 Z' />
        </svg>
      </div>
      <div className='am-container am-footer-inner'>
        <div className='am-footer-col am-footer-col-left'>
          <a href='#home' className='am-logo' aria-label='AM Facilities home'>
            <img src='/assets/amfacilities_logo_white.avif' alt='AM Facilities logo' />
          </a>
        </div>

        <div className='am-footer-col am-footer-col-center'>
          <h4>CONTACT US</h4>
          <p className='am-footer-contact'>
            <a href="tel:+16476752000" className='am-footer-contact-line am-footer-phone'>
              <svg className="am-footer-phone-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.51 1.51a15.09 15.09 0 01-6.59-6.59l1.51-1.51a.977.977 0 00.24-1.01C8.79 6.43 8.59 5.24 8.59 4.01 8.59 3.45 8.14 3 7.58 3H4.01C3.45 3 3 3.45 3 4.01 3 13.92 11.08 22 20.99 22c.56 0 1.01-.45 1.01-1.01v-3.57c0-.56-.45-1.01-1.01-1.01z" />
              </svg>
              +1 (647) 675-2000
            </a>
            <span className='am-footer-contact-line'>✉️ anna.maia@amfacilities.ca</span>
          </p>
          <div className='am-footer-follow'>
            <h4>FOLLOW US</h4>
            <div className='am-footer-socials'>
              <a
                href='https://www.instagram.com/amfacilities?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=='
                target='_blank'
                rel='noreferrer'
                aria-label='Instagram'
              >
                <img src='/assets/instagram_icon.png' alt='Instagram' />
              </a>
              <a href='https://g.page/r/CbK8FSvoU3W0EBM/review' target='_blank' rel='noreferrer' aria-label='Google'>
                <img src='/assets/google_icon.png' alt='Google' />
              </a>

            </div>
          </div>
        </div>

        <div className='am-footer-col am-footer-col-right'>
          <h4>HELP & INFORMATION</h4>
          <nav>
            <a href='/terms'>
              Terms & Conditions
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
